import { AddressFormResponse } from '@flipdish/api-client-typescript';

export const mapFormDataAddress = (formattedAddress: AddressFormResponse) => {
  const values = {};
  formattedAddress?.FormData?.forEach((element) => {
    values[element?.Identifier!] = element.Value || '';
  });
  return values;
};
